import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/CentralLibraryComponents/LibraryFaculty.tsx");
